import React from 'react';

import { classnames } from '../util';
import styles from './message.module.scss';

import exclamationRedIcon from '../../assets/svg/exclamation-red-icon.svg';
import exclamationGreenIcon from '../../assets/svg/exclamation-green-icon.svg';

export type MessageProps = {
  type: string;
  children: string;
  fullWidth: boolean;
};

const Message = (props: MessageProps) => {
  return (
    <div
      className={classnames(styles['Message'], {
        [styles['full-width']]: props.fullWidth,
        [styles['error-light']]: props.type === 'error-light',
        [styles['success-light']]: props.type === 'success-light',
      })}
    >
      {props.type !== 'info' && (
        <div className={styles['icon']}>
          {props.type === 'success-light' && (
            <img src={exclamationGreenIcon} alt='' />
          )}
          {props.type === 'error-light' && (
            <img src={exclamationRedIcon} alt='' />
          )}
        </div>
      )}
      <div className={styles['text']}>
        {props.type === 'info' && <h4>Note:</h4>}
        <p>{props.children}</p>
      </div>
    </div>
  );
};

export default Message;
